<template>
  <div>Config</div>
</template>

<script>
export default {

};
</script>

<style>

</style>
